import React from 'react';
import useReveal from '../useReveal';

// Shared IntersectionObserver entrance used by every home section.
export default function Reveal({ as: Tag = 'div', className = '', delay = 0, style, children, ...rest }) {
  const [ref, revealed] = useReveal();
  const cls = `pl-reveal${revealed ? ' is-revealed' : ''}${className ? ` ${className}` : ''}`;
  const mergedStyle = delay ? { ...style, transitionDelay: `${delay}ms` } : style;
  return (
    <Tag ref={ref} className={cls} style={mergedStyle} {...rest}>
      {children}
    </Tag>
  );
}
